import { Component, OnInit, Input, NgZone, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Instruction } from 'src/app/models/Instruction';
import { User } from 'src/app/models/User';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { GlobalMethodsService } from 'src/app/services/global-methods.service';
import { GlobalVariablesService } from 'src/app/services/global-variables.service';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { Subject } from 'rxjs';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';

@Component({
  selector: 'app-panic-code',
  templateUrl: './panic-code.component.html',
  styleUrls: ['./panic-code.component.scss'],
})
export class PanicCodeComponent implements OnInit, OnDestroy {

  public status: number = 1;
  public title: string;
  public subtitle: string;
  public panicCode: string;
  public titleStatus1: string;
  public subtitleStatus1: string;
  public titleStatus2: string;
  public titleStatus3: string;
  public subtitleStatus3: string;
  inputs;
  @Input('userName') userName: string;
  @Input('user') user: User;
  @Input('s_ins') s_ins: number;
  public updateCodeEvent = new Subject<boolean>();
  private isServiceBusy = false;

  constructor(private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    public gvs: GlobalVariablesService,
    private profileInstallationService: ProfileInstallationService,
    private defaultModalComponent: DefaultModalComponent,
    private zone: NgZone,
    private translate: TranslateConfigService) {
    this.statusUpdateCodeEvent().subscribe(async (status: boolean) => {
      this.zone.run(async () => {
        if (status) {
          await this.updateCode();
        }
      });
    });
  }

  async ngOnInit() {
    this.gms.loading();
    if (this.user.panic_code !== '') {
      this.status = 3;
    }
    await this.loadTexts();
    if (this.user.panic_code !== '') {
      this.title = this.titleStatus3;
      this.subtitle = this.subtitleStatus3;
    } else {
      this.title = this.titleStatus1;
      this.subtitle = this.subtitleStatus1;
    }
    this.inputs = document.querySelectorAll<HTMLInputElement>('#code > *[id]');
    this.modalCtrl.dismiss(false, '', 'loadSpinner');
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Codigo Coaccion', contentGroup: 'Configurar Codigo Coaccion'}); 
  }

  ngOnDestroy() {
    this.updateCodeEvent.unsubscribe();
  }

  async loadTexts() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let instructions: Instruction[] = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 25, 'SIC0200_0130', 'users');
      this.titleStatus1 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 26, 'SIC0200_0130', 'users');
      this.subtitleStatus1 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 27, 'SIC0200_0130', 'users');
      this.titleStatus2 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 28, 'SIC0200_0130', 'users');
      this.titleStatus3 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 29, 'SIC0200_0130', 'users');
      this.subtitleStatus3 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async dismiss(confirm: boolean, modalID: string , result?: boolean, user?: User) {
    await this.modalCtrl.dismiss({ confirm: confirm, result: result, user: user }, '', modalID);
  }

  onKeydown(event: any, i: number) {
    if (event.key === "Backspace") {
      this.inputs[i].value = '';
      if (i !== 0)
        this.inputs[i - 1].focus();
      event.preventDefault();
    } else {
      if ((i === this.inputs.length - 1 && this.inputs[i].value !== '') || isNaN(Number(event.key))) {
        this.inputs[i].value = '';
        event.preventDefault();
        return true;
      } else if (!isNaN(Number(event.key))) {
        this.inputs[i].value = event.key;
        if (i !== this.inputs.length - 1) {
          this.inputs[i + 1].focus();
        }
        if (this.status === 1 && this.inputs[0].value !== '' && this.inputs[1].value !== '' && this.inputs[2].value !== '' && this.inputs[3].value !== '') {
          this.setUpdateCodeEvent(true);
        }
        event.preventDefault();
      }
    }
  }

  async close() {
    if (this.status === 1) {
      await this.dismiss(false,'panicCodeModal', false, this.user);
    } else {
      await this.dismiss(true, 'panicCodeModal', true, this.user);
    }
  }


  async deleteCode() {
    if (this.isServiceBusy) {
      return;
    }
    this.isServiceBusy = true;
    await this.gms.loading();
    let tempUser: User = JSON.parse(JSON.stringify(this.user));
    tempUser.panic_code = '';
    const newUser = await this.updateConfDevice(tempUser);
    if (newUser === undefined) {
      return;
    }
    if (newUser != null) {
      await this.dismiss(true,'panicCodeModal', true, newUser);
    } else {
      await this.dismiss(true,'panicCodeModal', false, newUser);
    }
   this.modalCtrl.dismiss(false, '', 'loadSpinner');
    this.isServiceBusy = false;
  }

  async updateCode() {
    const inputs = document.querySelectorAll<HTMLInputElement>('#code > *[id]');
    if (inputs[0].value !== '' && inputs[1].value !== '' && inputs[2].value !== '' && inputs[3].value !== '') {
      await this.gms.loading();
      let tempUser: User = JSON.parse(JSON.stringify(this.user));
      tempUser.panic_code = inputs[0].value + inputs[1].value + inputs[2].value + inputs[3].value;
      const newUser = await this.updateConfDevice(tempUser);
      if (newUser === undefined) {
        this.gms.analyticsTrackEvent('event_coercion_code', {eventCategory: 'SICOR/Codigo Coaccion', eventAction: 'Error/Codigo Configurado OK'});
        return;
      }
     this.modalCtrl.dismiss(false, '', 'loadSpinner');
      if (newUser) {
        this.title = this.titleStatus2;
        this.subtitle = '';
        this.status = 2;
        this.user = newUser;
        this.gms.analyticsTrackEvent('event_coercion_code', {eventCategory: 'SICOR/Codigo Coaccion', eventAction: 'Accion/Codigo Configurado OK'});
      }
      else {
        this.gms.analyticsTrackEvent('event_coercion_code', {eventCategory: 'SICOR/Codigo Coaccion', eventAction: 'Error/Codigo Configurado OK'});
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.confCodeKo'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    }
  }

  async updateConfDevice(user: User) {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      return await this.profileInstallationService.cAppuserUserUpd(this.s_ins, user, 2, 'panicCodeComponent', this.userName);
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  public statusUpdateCodeEvent(): Subject<boolean> {
    return this.updateCodeEvent;
  }

  public setUpdateCodeEvent(value: boolean) {
    this.updateCodeEvent.next(value);
  }

}
